import { Link } from '@bpba/ui-components';
import { IIndexable } from '../model/IIndexable';
import { ProductoData } from '../model/ProductoData';
import { DETALLE_PATH } from '../components/detalle/Detalle';
import { URL_PATH_CDN } from '../constants/urls';
import { absoluteUrl } from '../utils/urlUtils';

export function productoDataMapping(item: IIndexable) {
  const enlace =
    item?.productoId && typeof item.productoId === 'string' && item.productoId.trim().length > 0
      ? new Link(`${process.env.PUBLIC_URL}${DETALLE_PATH}/${item.productoId.trim()}`)
      : undefined;

  const imagenes = item?.imagenes?.map?.((img: string) => `${URL_PATH_CDN}${img}`);

  const relacionados = item?.productosRelacionados?.map((relacionado: IIndexable) => productoDataMapping(relacionado));

  return new ProductoData(
    item.id,
    item.orden,
    item.titulo,
    item.descripcion,
    item.puntos,
    item.codigo,
    item.destacado,
    item.tipoProducto,
    item.rubroTitle,
    imagenes,
    item.rubroId,
    item.productoId,
    enlace,
    item.stock,
    item.iconoRubro,
    item.descripcionDetallada,
    relacionados,
    item.descuento,
    getLinkLocales(item)
  );
}
/** Si la ruta recibida no es absoluta, entonces se está
 * recibiendo la clave de un archivo en la CDN. En éste
 * último caso, se rearma la url utilizando la url
 * de la CDN.
 */
export function getLinkLocales(item: IIndexable) {
  if (!item?.link?.ruta || item.link.ruta.trim?.().length === 0) return undefined;

  const rutaLinkLocales = absoluteUrl(item.link.ruta) ? item.link.ruta : `${URL_PATH_CDN}${item.link.ruta}`;

  return new Link(rutaLinkLocales, item.link.isExterno, item.link.abreSolapa, item.link.tag);
}
